import { TableDashboardItemHelper } from 'src/app/components/table-dashboard-item/table-dashboard-item-helper';
import { TableColumnItem } from 'src/app/components/table-dashboard-item/table-dashboard-item.component';
import {
    IQueryContext,
    QueryContextSettingID,
} from 'src/app/services/query-context/models/IQueryContext';
import { DatasourceColumnId } from 'src/app/utils/datasource-sql-map/datasource';

export class SkanTableDashoardItemHelper {
    static tableSkanPostbacksColumnsGetter(
        context?: IQueryContext
    ): TableColumnItem[] {
        const prefixes = ['cnt'];
        const postfixes = [
            'NULL',
            ...Array.from({ length: 64 }, (_, i) => i.toString()),
        ];

        const cols: TableColumnItem[] = [];

        postfixes.forEach((num) => {
            prefixes.forEach((prefix) => {
                const id = `${prefix}_${num}`;
                cols.push({
                    id,
                    name: `${num}`,
                    nzLeft: false,
                    nzAlign: 'left',
                    nzSortFn: TableDashboardItemHelper.defaultSortFnGetter(
                        id,
                        'number'
                    ),
                });
            });
        });

        const colNonZero: TableColumnItem = {
            id: 'neq_0',
            name: '<> 0',
            nzLeft: false,
            nzAlign: 'left',
            nzSortFn: TableDashboardItemHelper.defaultSortFnGetter(
                'neq_0',
                'number'
            ),
        };

        cols.splice(2, 0, colNonZero);

        return cols.filter((metric: TableColumnItem) => {
            return (
                context?.settings[
                    QueryContextSettingID.SKADNETWORK_SELECTED_METRICS
                ]?.includes(metric.id) ?? true
            );
        });
    }

    static tableSkanPostbacksSortSplitColumnsFn(
        a: TableColumnItem,
        b: TableColumnItem
    ): number {
        const order: DatasourceColumnId[] = [
            'ATTRIBUTION_NETWORK_NAME',
            'ATTRIBUTION_CAMPAIGN_NAME',
            'ACTIVITY_DATE',
        ];
        const orderString: string[] = order.map((item) => {
            return item as string;
        });
        const idxA = orderString.indexOf(a.id);
        const idxB = orderString.indexOf(b.id);

        const posA = idxA === -1 ? Infinity : idxA;
        const posB = idxB === -1 ? Infinity : idxB;

        return posA - posB;
    }
}
